import { createSlice } from '@reduxjs/toolkit';

export const initState = {
    floorIds: { floorId: '', floorName: '' },
    floorIdPath: '',
    scannerNums: [],
    scannerList: [],
};

const { actions, reducer } = createSlice({
    name: 'scannerStatusLog',
    initState,
    reducers: {
        setFloorIds: (state, action) => {
            state.floorIds = action.payload;
        },
        setFloorIdPath: (state, action) => {
            state.floorIdPath = action.payload;
        },
        setScannerNums: (state, action) => {
            state.scannerNums = action.payload;
        },
        setScannerList: (state, action) => {
            state.scannerList = action.payload;
        },
        reset: (state, action) => {
            const initialState = { ...initState, ...action.payload };
            for (let key in initialState) {
                state[key] = initialState[key];
            }
        },
    },
});

export const { setFloorIds, setFloorIdPath, setScannerNums, setScannerList, reset } = actions;
export default reducer;
